var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _g, _g2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferredPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#E3F2FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#1976D2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 50 L200 80 L350 40 L500 100 L650 60 L750 90",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 150 L200 120 L350 160 L500 100 L650 140 L750 110",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 50 L50 150",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 80 L200 120",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350 40 L350 160",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M500 100 L500 100",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M650 60 L650 140",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M750 90 L750 110",
    fill: "none",
    stroke: "#BBDEFB",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 5,
    fill: "#2196F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 80,
    r: 5,
    fill: "#2196F3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 40,
    r: 5,
    fill: "#2196F3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 100,
    r: 8,
    fill: "#1976D2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 60,
    r: 5,
    fill: "#2196F3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 90,
    r: 5,
    fill: "#2196F3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 150,
    r: 5,
    fill: "#2196F3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 5,
    fill: "#2196F3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 160,
    r: 5,
    fill: "#2196F3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 140,
    r: 5,
    fill: "#2196F3"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 110,
    r: 5,
    fill: "#2196F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-40 0 C-30 -10, -20 -10, -10 0",
    fill: "none",
    stroke: "#1976D2",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40 0 C-30 10, -20 10, -10 0",
    fill: "none",
    stroke: "#1976D2",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0 C30 -10, 20 -10, 10 0",
    fill: "none",
    stroke: "#1976D2",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0 C30 10, 20 10, 10 0",
    fill: "none",
    stroke: "#1976D2",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -5,
    width: 20,
    height: 10,
    fill: "#1976D2",
    rx: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -50,
    width: 30,
    height: 80,
    fill: "#0D47A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -45,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -45,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -35,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -35,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -25,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -25,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -40,
    width: 20,
    height: 70,
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -35,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -35,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -25,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -25,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -30,
    width: 15,
    height: 60,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: -25,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: -15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: -5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 5,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 5,
    height: 5,
    fill: "#BBDEFB"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 35,
    fontWeight: "bold",
    fill: "#0D47A1",
    textAnchor: "middle"
  }, "PREFERRED PARTNER")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 110,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#0D47A1",
    textAnchor: "middle"
  }, "15% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 140,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#1976D2",
    textAnchor: "middle"
  }, "Exclusive discount for our business partners")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferredPartner);
export default __webpack_public_path__ + "static/media/preferred_partner.f146593efff79158e50e9a6ef7fe1377.svg";
export { ForwardRef as ReactComponent };